<script setup>
import { ref , defineEmits} from 'vue'
const sliderModel = ref(null)
const categories = ref([
  {
    title: 'ابتدایی',
    chips: [
      {
        name: 'اول',
        value: 1,
        isActive: false
      },
      {
        name: 'دوم',
        value: 2,
        isActive: false
      },
      {
        name: 'سوم',
        value: 3,
        isActive: false
      },
      {
        name: 'چهارم',
        value: 4,
        isActive: false
      },
      {
        name: 'پنجم',
        value: 5,
        isActive: false
      },
      {
        name: 'ششم',
        value: 6,
        isActive: false
      }
    ]
  },
  {
    title: 'متوسطه اول',
    chips: [
      {
        name: 'هفتم',
        value: 7,
        isActive: false
      },
      {
        name: 'هشتم',
        value: 8,
        isActive: false
      },
      {
        name: 'نهم',
        value: 9,
        isActive: false
      }
    ]
  },
  {
    title: 'متوسطه دوم (کنکور)',
    chips: [
      {
        name: 'دهم',
        value: 10,
        isActive: false
      },
      {
        name: 'یازدهم',
        value: 11,
        isActive: false
      },
      {
        name: 'دوازدهم',
        value: 12,
        isActive: true
      }
    ]
  }
])
const emit = defineEmits(['atChangeChip'])

const activateChip = (selectedChip) => {
  categories.value.forEach(category => {
    category.chips.forEach(chip => {
      chip.isActive = chip.value === selectedChip.value
    })
  })
  emit('atChangeChip', selectedChip.value)

}

</script>

<template>
  <v-row class="mb-10 d-flex justify-center">
    <v-slide-group
      v-if="$vuetify.display.mdAndDown"
      v-model="sliderModel"
      class="pa-4"
      :show-arrows="false"
      center-active
    >
      <v-slide-group-item
        v-for="(item, index) in categories"
        :key="index"

      >
        <div class="d-flex flex-column">
          <div class="mb-2 font-weight-bold">{{ item.title }}</div>
          <div class="mt-2 d-flex justify-content-center">
            <v-chip
              border
              :variant="chip.isActive?'tonal': 'text'"
              :color="chip.isActive ? 'primary' : '' "
              class="rounded-lg mx-1 font-weight-bold"
              :class="chip.isActive?'border-primary':'border-gray-light'"
              v-for="chip in item.chips" :key="chip.value" @click="activateChip(chip)"
              :prepend-icon="chip.isActive?'$mdiCheck':''"
            >
              {{ chip.name }}
            </v-chip>
          </div>
        </div>
      </v-slide-group-item>
    </v-slide-group>
    <v-col
      v-else
      cols="4"
      class="d-flex justify-content-center align-items-center flex-column"
      v-for="(item, index) in categories" :key="index">
      <div class="mb-2 font-weight-bold">{{ item.title }}</div>
      <div class="mt-2 d-flex justify-content-center">
        <v-chip
          border
          :variant="chip.isActive?'tonal': 'text'"
          :color="chip.isActive ? 'primary' : '' "
          class="rounded-lg mx-1 font-weight-bold"
          :class="chip.isActive?'border-primary':'border-gray-light'"
          v-for="chip in item.chips" :key="chip.value" @click="activateChip(chip)"
          :prepend-icon="chip.isActive?'$mdiCheck':''"
        >
          {{ chip.name }}
        </v-chip>
      </div>
    </v-col>
  </v-row>
</template>

<style scoped lang="scss">

</style>
